import React, { useState } from 'react';
import Header from '../../components/ui/Header';
import SecurityHeader from './components/SecurityHeader';
import TwoFactorAuth from './components/TwoFactorAuth';
import DeviceManagement from './components/DeviceManagement';
import SecurityAuditLog from './components/SecurityAuditLog';
import PasswordManagement from './components/PasswordManagement';
import SecurityAssessment from './components/SecurityAssessment';
import Icon from '../../components/AppIcon';

const SecurityCenter = () => {
  const [activeTab, setActiveTab] = useState('overview');
  const securityScore = 80;

  const tabs = [
    { id: 'overview', label: 'Overview', icon: 'LayoutDashboard' },
    { id: '2fa', label: 'Two-Factor Auth', icon: 'ShieldCheck' },
    { id: 'devices', label: 'Devices', icon: 'Laptop' },
    { id: 'password', label: 'Password', icon: 'Lock' },
    { id: 'audit', label: 'Audit Log', icon: 'FileText' }
  ];

  const renderContent = () => {
    switch (activeTab) {
      case 'overview':
        return <SecurityAssessment />;
      case '2fa':
        return <TwoFactorAuth />;
      case 'devices':
        return <DeviceManagement />;
      case 'password':
        return <PasswordManagement />;
      case 'audit':
        return <SecurityAuditLog />;
      default:
        return <SecurityAssessment />;
    }
  };

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main className="pt-20 pb-12 px-4 md:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <SecurityHeader securityScore={securityScore} />

          <div className="bg-card rounded-lg shadow-md mb-6 overflow-x-auto">
            <div className="flex border-b border-border min-w-max">
              {tabs?.map((tab) => (
                <button
                  key={tab?.id}
                  onClick={() => setActiveTab(tab?.id)}
                  className={`flex items-center gap-2 px-4 md:px-6 py-3 md:py-4 text-sm md:text-base font-medium transition-colors whitespace-nowrap ${
                    activeTab === tab?.id
                      ? 'text-primary border-b-2 border-primary bg-primary/5' :'text-muted-foreground hover:text-foreground hover:bg-muted/50'
                  }`}
                >
                  <Icon name={tab?.icon} size={18} />
                  <span>{tab?.label}</span>
                </button>
              ))}
            </div>
          </div>

          {renderContent()}

          <div className="mt-8 bg-muted/30 border border-border rounded-lg p-6">
            <div className="flex flex-col lg:flex-row items-start lg:items-center justify-between gap-4">
              <div className="flex items-start gap-3">
                <Icon name="HelpCircle" size={24} color="var(--color-primary)" className="flex-shrink-0 mt-1" />
                <div>
                  <h3 className="text-lg font-semibold text-foreground mb-1">Need Help with Security?</h3>
                  <p className="text-sm text-muted-foreground">
                    Our security team is available 24/7 to help you protect your account and assets. Contact us for personalized security guidance.
                  </p>
                </div>
              </div>
              <button className="px-6 py-2 bg-primary text-primary-foreground rounded-lg font-medium hover:bg-primary/90 transition-colors whitespace-nowrap flex-shrink-0">
                Contact Support
              </button>
            </div>
          </div>
        </div>
      </main>
      <footer className="bg-card border-t border-border py-6 px-4 md:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <div className="flex items-center gap-2 text-sm text-muted-foreground">
              <Icon name="Lock" size={16} />
              <span>© {new Date()?.getFullYear()} Kryptostash. All rights reserved.</span>
            </div>
            <div className="flex items-center gap-6 text-sm">
              <a href="#" className="text-muted-foreground hover:text-foreground transition-colors">Privacy Policy</a>
              <a href="#" className="text-muted-foreground hover:text-foreground transition-colors">Terms of Service</a>
              <a href="#" className="text-muted-foreground hover:text-foreground transition-colors">Security</a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default SecurityCenter;